module.exports = __webpack_public_path__ + "static/media/solution-tube-k_-open.ce00511a.svg";